<app-menu></app-menu>
<div class="container">
  <div class="jumbotron">
    <h1 *ngIf="!nombreUsuario" class="display-4">Hello, world!</h1>
    <h1 *ngIf="nombreUsuario" class="display-4">Hello, {{ nombreUsuario }}</h1>
    <p class="lead">
      This is a simple hero unit, a simple jumbotron-style component for calling
      extra attention to featured content or information.
    </p>
    <hr class="my-4" />
    <p>
      It uses utility classes for typography and spacing to space content out
      within the larger container.
    </p>
    <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a>
  </div>
</div>
